import {html, css, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
@customElement('gmk-countdown')
export class CountdownElement extends LitElement {

    static styles = css`
        .countdown-number {
            color: #fff;
            background: #000;
            justify-content: center;
            width: 100%;
            display: inline-flex;
            font-size: 40px;
            font-weight: 700;
            padding: 10px 0 5px;
        }

        .countdown-label {
            color: #fff;
            background: #000;
            text-align: center;
            font-size: 12px;
            font-weight: 700;
            padding-bottom: 10px;
            margin: 0;
        }
    `;

    @property({type: String}) unit = '';
    @property({type: String}) targetdate = '';
    @property({type: Number}) remainingTime = 0;
    private interval: number;

    render() {
        return html`
        <span class="countdown-number">${this.remainingTime}</span>
        <p class="countdown-label">${this._label(this.unit)}</p>
        `;
    }

    connectedCallback() {
        super.connectedCallback();
        this.interval = window.setInterval(() => {
        let target = new Date(this.targetdate);
        const targetMs = new Date(target).getTime();
        const diffMs = targetMs - Date.now();
        const totalSeconds = Math.floor(diffMs / 1000);
        const timeLeft = this._timeValue(this.unit, diffMs);
        this.remainingTime = timeLeft;
        }, 500);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        window.clearInterval(this.interval);
    }

    _label(unit: String) {
        switch(unit) {
            case 'seconds'  : return 'Sekunden';
            case 'minutes'  : return 'Minuten';
            case 'hours'    : return 'Stunden';
            case 'days'     : return 'Tage';
        }
    }

    private _timeValue: (unit: String, time: number) => number = function (unit: String, time: number) {
        const totalSeconds = Math.floor(time / 1000);
        switch(unit) {
            case 'seconds'  : return totalSeconds % 60;
            case 'minutes'  : return Math.floor((totalSeconds % 3600) / 60);
            case 'hours'    : return Math.floor((totalSeconds % 86400) / 3600);
            case 'days'     : return Math.floor(totalSeconds / 86400);
            default: return 0;
        }
    }
}

